import gql from "graphql-tag";

export const queryPages = gql`
  query Pages($id: String!) {
    contentFragment(group: "pages", key: $id) {
      text
    }
  }
`;
